import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as FilterIcon } from "../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../src/assets/Customer/FilterIconHover.svg";
import CommonUtil from "../Util/CommonUtils";
import CancelButtons from "../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../components/DialogBoxComponent/SubmitButtons";
import { getAllSites } from "../slices/Site/SiteSlice";
import { getAllVisitorType } from "../slices/VisitorType/VisitorTypeSlice";
import { ThemeContext } from "../theme/ThemeContext";
import AutocompleteComponent from "./CustomInputs/AutocompleteComponent";
import CustomDateTimePicker from "./CustomInputs/CustomDateTimePicker";
import CustomTextfield from "./CustomInputs/CustomTextfield";
import Toast from "./ToastContainer/CustomToast";

export default function InvitationFilterFromReport(props) {
  const [open, setOpen] = React.useState(false);
  const [siteData, setSiteData] = useState([]);
  const [visitorData, setVisitorData] = useState([]);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [changeDate, setDateChange] = useState(true);
  const [dateOpen, setDateOpen] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };
  var today = new Date();
  var endDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T23:59:59";
  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T00:00";

  const [payload, setPayload] = useState({
    purposeTypeId: "",
    siteId: "",
    firstName: "",
    lastName: "",
    scheduledStartDate: CommonUtil.formatToUtc(startDate),
    scheduledEndDate: CommonUtil.formatToUtc(endDate),
    visitMode: props.selectedObject,
    status: props.status,
  });

  const handleClose = () => {
    setPayload({
      purposeTypeId: "",
      siteId: "",
      firstName: "",
      lastName: "",
      scheduledStartDate: CommonUtil.formatToUtc(startDate),
      scheduledEndDate: CommonUtil.formatToUtc(endDate),
      visitMode: props.selectedObject,
      status: props.status,
    });
    setOpen(false);
    setDateOpen(props.open);
    setDiaLogBoxBlur(false);
  };

  const [error, setError] = useState({
    purposeTypeId: false,
    siteId: false,
    firstName: false,
    lastName: false,
  });

  const reset = () => {
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      [name]: false,
    });
  };

  if (open) {
    setDiaLogBoxBlur(true);
  }

  const handleSubmit = () => {
    if (
      payload.purposeTypeId.trim() === "" &&
      payload.siteId.trim() === "" &&
      payload.firstName.trim() === "" &&
      payload.lastName.trim() === "" &&
      payload.scheduledStartDate === null &&
      payload.scheduledEndDate === null
    ) {
      Toast(t("COMMON015"), "error");
      return;
    }

    if (
      payload.scheduledStartDate === null ||
      payload.scheduledStartDate === undefined ||
      payload.scheduledStartDate === ""
    ) {
      setError({ scheduledStartDate: true });
      Toast(t("INVITESTARTDATEERROR"), "error");
      return;
    }

    if (
      payload.scheduledEndDate === null ||
      payload.scheduledEndDate === undefined ||
      payload.scheduledEndDate === ""
    ) {
      setError({ scheduledEndDate: true });
      Toast(t("INVITEENDDATEERROR"), "error");
      return;
    }

    if (
      new Date(payload.scheduledStartDate).toString() === "Invalid Date" ||
      new Date(payload.scheduledEndDate).toString() === "Invalid Date"
    ) {
      Toast(t("USERPROFSCREEN013"), "error");
      return;
    }

    if (
      new Date(payload.scheduledEndDate) < new Date(payload.scheduledStartDate)
    ) {
      Toast(t("INVITATIONFORM010"), "error");
      return;
    }

    props.applyFilter(payload);
    setPayload({
      purposeTypeId: "",
      siteId: "",
      firstName: "",
      lastName: "",
      scheduledStartDate: CommonUtil.formatToUtc(startDate),
      scheduledEndDate: CommonUtil.formatToUtc(endDate),
      registrationMode: props.selectedObject,
    });
    handleClose();
  };

  const loadData = () => {
    loadVisitorType();
    loadSites();
  };

  const loadVisitorType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getAllVisitorType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setVisitorData(data.data.visitorTypes);
        } else {
          setVisitorData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const loadSites = () => {
    const query = {
      page: 1,
      rowsPerPage: 10000,
      name: "",
    };
    dispatch(getAllSites(query))
      .unwrap()
      .then((data) => {
        if (data.code === "LMSI0000") {
          setSiteData(data.data.site);
          setDateChange(true);
        } else {
          setSiteData([]);
        }
      });
  };

  const onselectVisitorType = (event) => {
    setPayload({
      ...payload,
      visitorTypeId: event.id,
    });
  };

  const onselectSite = (event) => {
    setPayload({
      ...payload,
      siteId: event.id,
    });
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const statusValue = props.status;

  const formatStatus = (value) => {
    if (!value) return "";

    return value
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleStatusChange = (event, value) => {
    setPayload({
      ...payload,
      status: value,
    });
  };

  return (
    <>
      <Tooltip
        title={
          <Typography fontSize={12} fontWeight={500}>
            {t("COMMON006")}
          </Typography>
        }
      >
        <span
          className={darkMode ? "filterdark" : "filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => {
            setOpen(true);
            loadData();
          }}
        >
          {isHovered ? (
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <InvitationFilterFromReport />
            </FilterIconHover>
          ) : (
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <InvitationFilterFromReport />
            </FilterIcon>
          )}
        </span>
      </Tooltip>
      <Grid item xs={6}>
        <Dialog
          open={open}
          disableBackdropClick
          disableEscapeKeyDown
          BackdropProps={{
            style: {
              backdropFilter: "blur(5px)",
            },
          }}
        >
          <DialogTitle
            variant="h4"
            style={{
              color: darkMode ? "#fff" : "",
              backgroundColor: darkMode ? "#0E2A41" : "#fff",
            }}
          >
            <IconButton
              aria-label="close"
              sx={{
                position: "absolute",
                right: 15,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon onClick={handleClose} />
            </IconButton>
            {t("COMMON006")}
          </DialogTitle>
          <Divider
            variant="middle"
            style={{
              background: darkMode
                ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
                : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
              height: "1px",
              opacity: 0.5,
            }}
          />

          <DialogContent
            style={{
              backgroundColor: darkMode ? "#0E2A41" : "#fff",
              paddingBottom: "0px",
            }}
          >
            <Grid
              container
              rowSpacing={2}
              justifyContent="center"
              alignItems={"center"}
            >
              <Grid item xs={12} sm={12}>
                <CustomTextfield
                  label={t("VISITOR_FIRST_NAME")}
                  error={error.firstName}
                  name="firstName"
                  value={payload.firstName}
                  handleChange={(e) => handleChange(e)}
                  helperText={error.firstName}
                  autoComplete="on"
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <CustomTextfield
                  label={t("VISITOR_LAST_NAME")}
                  error={error.lastName}
                  name="lastName"
                  value={payload.lastName}
                  handleChange={(e) => handleChange(e)}
                  helperText={error.lastName}
                  autoComplete="on"
                />
              </Grid>

              {Array.isArray(statusValue) && (
                <Grid item xs={12} sm={12}>
                  <Autocomplete
                    popupIcon={<ExpandMoreIcon />}
                    options={
                      CommonUtil.isEmptyArray(statusValue) ? [] : statusValue
                    }
                    onChange={handleStatusChange}
                    getOptionLabel={(option) => formatStatus(option)}
                    renderInput={(params) => (
                      <TextField {...params} label={t("COMMON001")} />
                    )}
                  />
                </Grid>
              )}

              <Grid item xs={12} sm={12}>
                <AutocompleteComponent
                  sx={{
                    "& .MuiAutocomplete-clearIndicator": {
                      color: "#949596",
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#949596",
                    },
                  }}
                  label={t("COMMON068")}
                  name="visitorTypeId"
                  error={error.visitorTypeId}
                  value={payload.visitorTypeId}
                  isOptionEqualToValue={(option, value) =>
                    option.name === value
                  }
                  onSelect={(e) => onselectVisitorType(e)}
                  options={visitorData}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <AutocompleteComponent
                  sx={{
                    "& .MuiAutocomplete-clearIndicator": {
                      color: "#949596",
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#949596",
                    },
                  }}
                  label={t("SITE013")}
                  name="siteId"
                  error={error.siteId}
                  value={payload.siteId}
                  isOptionEqualToValue={(option, value) =>
                    option.name === value
                  }
                  onSelect={(e) => onselectSite(e)}
                  options={siteData}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <CustomDateTimePicker
                  onChange={(scheduledStartDate) =>
                    setPayload({
                      ...payload,
                      scheduledStartDate: scheduledStartDate,
                    })
                  }
                  value={payload.scheduledStartDate}
                  label={t("INVITESTARTDATEERROR1")}
                  changeDate={changeDate}
                  date={props.date}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <CustomDateTimePicker
                  onChange={(scheduledEndDate) =>
                    setPayload({
                      ...payload,
                      scheduledEndDate: scheduledEndDate,
                    })
                  }
                  value={payload.scheduledEndDate}
                  // minDateTime={payload.scheduledStartDate}
                  label={t("INVITESTARTDATEERROR2")}
                  changeDate={changeDate}
                  date={props.date}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            style={{
              justifyContent: "center",
              backgroundColor: darkMode ? "#0E2A41" : "#fff",
            }}
          >
            <CancelButtons
              variant="contained"
              color="secondary"
              onClick={reset}
            >
              <Typography variant="body1" style={{ textTransform: "none" }}>
                {t("COMMON008")}
              </Typography>
            </CancelButtons>
            <SubmitButtons variant="contained" onClick={handleSubmit}>
              <Typography variant="body1" style={{ textTransform: "none" }}>
                {t("COMMON024")}
              </Typography>
            </SubmitButtons>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
}
